import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const ThumbsDown: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <path
      fill={props.fill}
      d="M39.7 20c.1 1.8-1.3 3.3-3.1 3.3h-1.2c1.8 0 3.2 1.5 3.1 3.3-.1 1.7-1.6 3-3.3 3H22.1l.7 2.1c.8 2.5 1.1 5.2.7 7.8-.3 1.9-1.1 4-3.4 4-1.5 0-2.8-1.1-3.1-2.6-.9-4.9-3.7-10-7.2-13.6-.9-1-1.4-2.2-1.4-3.6V10.6c0-2.2 1.3-4.2 3.3-5.1 1.4-.6 2.9-1 4.6-1H33c1.7 0 3.2 1.3 3.3 3 .1 1.8-1.3 3.3-3.1 3.3h1.6c1.7 0 3.2 1.3 3.3 3 .1 1.8-1.3 3.3-3.1 3.3h1.4c1.7-.1 3.2 1.2 3.3 2.9Z"
    />
  </Box>
)
export default ThumbsDown
